<template>
    <el-dialog :visible.sync="showDialog" :close-on-click-modal="false" @close="handleReset">
        <template #title>
            <h4>{{$t('lang.导入食谱')}}</h4>
        </template>
        <el-form label-width="auto" ref="form" :model="formData">


            <el-form-item label="文件" prop="fileList" :rules="{required: true, message: this.$t('lang.请上传文件'), trigger: 'blur'}">
                <el-upload
                        :action="$api.recipe.importData"
                        accept=".zip"
                        :auto-upload="false"
                        ref="upload"
                        :on-exceed="handleExceed"
                        :on-success="handleSuccess"
                        :on-change="handleUploadChange"
                        :data="params"
                        :limit="1">
                    <el-button size="small" type="primary">{{ $t('lang.上传文件') }}</el-button>
                    <div slot="tip" class="el-upload__tip">{{$t('lang.只能上传zip文件')}}</div>
                </el-upload>
            </el-form-item>

            <el-form-item class="search-form-item" :label="$t('lang.语言分类')" prop="lang" :rules="{required: true, message: this.$t('lang.请选择语言'), trigger: 'change'}">
                <el-select clearable v-model="formData.lang">
                    <el-option v-for="item in supportLangList" :key="item.value" :value="item.value"
                               :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('lang.下载模版')">
                <el-link type="primary" @click="handleDownloadTemplate">{{$t('lang.模版文件')}}</el-link>
            </el-form-item>

            <el-form-item :label="$t('lang.兼容机型')" prop="productCodes" :rules="{required: true, message: this.$t('lang.请选择型号（机型）'), trigger: 'blur'}">
                <el-checkbox-group v-model="formData.productCodes">
                    <el-checkbox
                            v-for="item in productList"
                            :key="item.productCode"
                            :label="item.productCode">{{item.productModel}}
                    </el-checkbox>
                </el-checkbox-group>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="handleImport">{{ $t('lang.导入') }}</el-button>
                <el-button @click="handleReset">{{ $t('lang.重置') }}</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
    import {loadBrandOwnerProduct} from "../../js/common";

    export default {
        name: "RecipeImport",
        data() {
            return {
                showDialog: false,
                formData: {
                    productCodes: [],
                    fileList: [],
                    lang: ''
                },
                productList: [],
                timer: null,
            }
        },
        async created() {
            this.productList = await loadBrandOwnerProduct(this, this.$store.state.userInfo.brandOwnerCode);
        },
        methods: {
            // 导入
            handleImport() {
                this.$refs.form.validate((valid) => {
                    if (!valid) return;
                    this.$refs.upload.submit();
                })
            },

            handleUploadChange(file, fileList) {
                this.formData.fileList = fileList;
            },

            handleSuccess(res) {
                this.$customLoading.showLoading(this, "导入中")
                console.log('res', res);
                if (res.status !== 200) {
                    this.$message.error(res.desc);
                    this.$customLoading.hideLoading();
                    return;
                }
                this.handleCheckState(res);
                this.showDialog = false;
            },


            // 判断状态
            handleCheckState(res) {
                let asyncTask = res.data.asyncTask;
                switch (asyncTask.status) {
                    case  "RUNNING":
                        this.handleCheckImportState(asyncTask.code)
                        break;
                    case  "FINISH":
                        this.$message.success(this.$t('lang.导入成功'));
                        this.$customLoading.hideLoading();
                        this.$emit("refresh");
                        break;
                    case  "ERROR":
                        this.$message.error(this.$t('lang.导入失败'));
                        this.$customLoading.hideLoading();
                        break;
                }
            },

            // 轮询检测导入状态
            handleCheckImportState(code) {
                this.timer = setTimeout(() => {
                    this.$http.post(this.$api.recipe.asyncTaskDetail, this.$qs.stringify({code})).then(res => {
                        this.handleCheckState(res.data);
                    }).catch(err => {
                        console.log('err', err);
                    })
                }, 2000)
            },

            handleExceed() {
                this.$message.warning(this.$t('lang.只能上传一个文件'));
            },

            // 下载模版
            handleDownloadTemplate() {
                // // 创建 a 标签并设置下载地址
                // const a = document.createElement('a')
                // a.href = '/recipe.xlsx';
                // a.download = 'recipe.xlsx'
                // a.click()
                // a.remove()
                this.handleExport()
            },

            handleReset() {
                this.formData.productCodes = [];
                this.$refs.upload.clearFiles();
                this.$refs.form.resetFields();
            },
            handleExport() {

                if (!this.formData.lang) {

                    this.$message.warning("请选择语言");
                    return
                }

                this.$customLoading.showLoading(this, "请稍后");
                let params = Object.assign({}, this.params, this.formData)
                this.$http.post(this.$api.recipe.export, this.$qs.stringify(Object.assign(params, {type: 'tpl'}))).then(res => {
                    if (res.data.status != 200) {
                        this.$message.error(res.data.desc);
                        this.$customLoading.hideLoading();
                        return;
                    }
                    console.log("res", res);
                    this.handleCheckState2(res);
                }).catch(err => {
                    this.$customLoading.hideLoading();
                    console.log('err', err);
                })
                this.showDialog = false

            },

            // 判断状态
            handleCheckState2(res) {
                let asyncTask = res.data.data.asyncTask;
                let result = null;
                switch (asyncTask.status) {
                    case  "RUNNING":
                        this.handleCheckDownloadState2(asyncTask.code)
                        break;
                    case  "FINISH":
                        result = JSON.parse(asyncTask.result);
                        this.handleDownloadFile2(this.$api.file.download + '?fileCode=' + result.fileCode);
                        this.$customLoading.hideLoading();
                        break;
                    case  "ERROR":
                        this.$message.error(this.$t('lang.导出失败'));
                        this.$customLoading.hideLoading();
                        break;
                }
            },

            // 轮询检测导出状态
            handleCheckDownloadState2(code) {
                this.timer = setTimeout(() => {
                    this.$http.post(this.$api.recipe.asyncTaskDetail, this.$qs.stringify({code})).then(res => {
                        this.handleCheckState2(res);
                    }).catch(err => {
                        console.log('err', err);
                    })
                }, 2000)
            },

            // 创建a标签下载
            handleDownloadFile2(url) {
                let a = document.createElement('a');
                a.href = url;
                a.click();
                a.remove();
            },


        },
        computed: {
            supportLangList() {
                return this.$store.state.supportLangList;
            },
            params() {
                return {
                    lang: this.formData.lang,
                    productCodes: this.formData.productCodes.join(","),
                    brandOwnerNumber: this.$store.state.userInfo.brandOwnerNumber,
                }
            }
        },
        destroyed() {
            clearTimeout(this.timer)
        }
    }
</script>

<style scoped>

    h4 {
        padding: 0;
        margin: 0;
    }

    /deep/ .el-dialog {
        width: 450px;
        border-radius: 10px;
    }

    .el-select {
        width: 100%;
    }


</style>
